export default __webpack_public_path__ + "static/media/mygenehistory.23e0bd41.svg";